module.exports = __webpack_public_path__ + "img/icon-gs.f33ff5cc.png";